import React, { useState, useEffect } from 'react';
import { notify } from '../../notifications/notification';
import { generateTable } from '../../utils/tables';
import styles from './achizitii.module.scss';
import CButton from '../../components/button/button';
import CCollapseTable from '../../components/collapse/collapse-tables';
import { Space } from '../../components/utils/utils';
import { variables } from '../../utils/variables';
import CInput from '../../components/input/input';
import '../../theme/global.scss';
import { getTables } from '../../network/situatie';
import { ISituatie } from '../../utils/interfaces/interfaces';
const dummy_data: any[] | (() => any[]) = [];

const Achizitii = () => {
  const [dataSource, setSource] = useState(dummy_data);
  const [year, setYear] = useState('');

  const getTablesData = () =>
    getTables().then(({ data }) =>
      setSource(
        data.data.map((entry: ISituatie, index: number) => ({
          id: index,
          year: entry.year,
          entries: entry.entries.map(entry => ({
            ...entry,
            angajamentBugetar: entry.angajamentBugetar.split('#')[0] || '-',
            dataAngajamentBugetar: entry.angajamentBugetar.split('#')[1] || '-',
            angajamentLegal: entry.angajamentLegal.split('#')[0] || '-',
            dataAngajamentLegal: entry.angajamentLegal.split('#')[1] || '-',
            facturaNr:
              (entry.facturaNrData && entry.facturaNrData.split('#')[0]) || '-',
            facturaData:
              (entry.facturaNrData && entry.facturaNrData.split('#')[1]) || '-',
            ordonantarePlataNr:
              (entry.ordonantarePlata &&
                entry.ordonantarePlata.split('#')[0]) ||
              '-',
            ordonantarePlataData:
              (entry.ordonantarePlata &&
                entry.ordonantarePlata.split('#')[1]) ||
              '-',
            nrDataNotaIntrareReceptie:
              entry.nrDataNotaIntrareReceptie.split('#')[0] || '-',
            dataDataNotaIntrareReceptie:
              entry.nrDataNotaIntrareReceptie.split('#')[1] || '-'
          }))
        }))
      )
    );

  useEffect(() => {
    getTablesData();
  }, []);

  const updateData = (year: number, updated: any) => {
    setSource(dataSource.map(entry => (entry.year === year ? updated : entry)));
  };

  const addTable = () => {
    if (year.length > 0) {
      setSource(data => data.concat(generateTable(year)));
    } else {
      notify('Vă rugăm, introduceți un an.', 'warning');
    }
  };

  return (
    <div className={styles.container}>
      <p className='body-dark'>
        Introduceți un an pentru a genera un tabel pentru anul respectiv
      </p>
      <div className='row-auto'>
        <CInput
          label=''
          id='an'
          name='an'
          type='text'
          placeholder='An'
          value={year}
          onChange={event => setYear(event.target.value)}
        />
        <Space horizontal={variables.horizontalSpace} />
        <CButton label='Generează tabel' onClick={addTable} type='button' />
      </div>
      <Space vertical={variables.verticalSpace} />
      {dataSource.map(source => (
        <CCollapseTable
          source={source}
          updateSource={updateData}
          key={source.id}
          getTablesData={getTablesData}
        />
      ))}
    </div>
  );
};

export default Achizitii;
